import axiosInstance from "utils/InstanceAxios/InstanceAxios";
import axiosInstanceV2 from "utils/InstanceAxios/InstanceAxiosV2";
import { Types } from "../reducers/pipelines";
import { Pipelines } from "utils/consts/serverRoutes";
import { toast } from "react-toastify";
import errorMessages from 'utils/consts/errors';

//Synchronous
export const clearPipelineRegister = () => {
  return (dispatch) => {
    dispatch({
      type: Types.CLEAR_PIPELINES_REGISTER,
    });
  };
};

//Asynchronous
export const getJupyterhubFileSystem = (userId, directory, callback) => {
  return (dispatch) => {
    dispatch({ type: Types.SET_LOADING });
    axiosInstanceV2
      .get(Pipelines.jupyterhubFileSystem(userId, directory))
      .then((response) => {
        dispatch({
          type: "GET_JUPYTERHUB_FILE_SYSTEM",
          directory,
          payload: response.data,
        });
        if (callback) callback(true, response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: "GET_JUPYTERHUB_FILE_SYSTEM",
          payload: [],
        });
        if (callback) callback(false, err);
      });
  };
};

export const createPipeline = (pipeline, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .post(Pipelines.create(), pipeline)
      .then((response) => {
        dispatch({
          type: Types.CREATE_PIPELINE,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.error || err.response?.data || err.message) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
      });
  };
};

export const updatePipeline = (pipelineId, pipelineData, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .put(Pipelines.rud(`/${pipelineId}`), pipelineData)
      .then((response) => {
        dispatch({
          type: Types.UPDATE_PIPELINE,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        const message = (err.response?.data?.error || err.response?.data || err.message) || err.message;
        const errorMessage = errorMessages[message] || message;
        callback(false, errorMessage);
      });
  };
};

export const getPipeline = (pipelineId) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    dispatch({
      type: Types.GET_PIPELINE,
      payload: null,
    });
    axiosInstanceV2
      .get(Pipelines.rud(`/${pipelineId}`))
      .then((response) => {
        dispatch({
          type: Types.GET_PIPELINE,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_PIPELINE,
          payload: null,
        });
      });
  };
};

export const getAllPipelines = (page, limit, query, sort = "", filters = {}) => {
  return (dispatch) => {
    dispatch({
      type: Types.GET_ALL_PIPELINES,
      payload: { pipelines: [], maxPages: 1 },
    });
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(Pipelines.getAll(''), { params: { page, limit, query, sort } })
      .then((response) => {
        dispatch({
          type: Types.GET_ALL_PIPELINES,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_ALL_PIPELINES,
          payload: { pipelines: [], maxPages: 1 },
        });
      });
  };
};

export const deletePipeline = (pipelineId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstanceV2
      .delete(Pipelines.rud(`/${pipelineId}`))
      .then((response) => {
        dispatch({
          type: Types.DELETE_PIPELINE,
          payload: response.data
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err)
        callback(false);
      })
  };
};

export const inactivatePipeline = (pipelineId, callback) => {
  return (dispatch, getState) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    const { pipelines } = getState();

    axiosInstance
      .put(Pipelines.inactivatePipeline(`/${pipelineId}`))
      .then((response) => {
        dispatch({
          type: Types.INACTIVATE_PIPELINE,
          payload: response.data,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.INACTIVATE_PIPELINE,
          payload: pipelines.pipelines,
        });

        const message = (err.response?.data?.error || err.response?.data || err.message) || err.message;
        const errorMessage = errorMessages[message] || message;
        toast.error(errorMessage, { autoClose: 10000 });
      });
  };
};

export const savePipelineCreation = (pipeline, callback) => {
  return (dispatch) => {
    axiosInstanceV2
      .post(Pipelines.save(""), pipeline)
      .then((response) => {
        dispatch({
          type: Types.SAVE_PIPELINE_CREATION,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        callback(false);
        console.log(err);
      });
  };
};

export const addNewPipelineExecution = (pipelineId, callback) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .post(Pipelines.addNewPipelineExecution(pipelineId))
      .then((response) => {
        dispatch({
          type: Types.ADD_NEW_PIPELINE_EXECUTION,

        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.ADD_NEW_PIPELINE_EXECUTION,
        });
        callback(false);
      });
  };
}

export const getUsePipelines = (
 params
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(Pipelines
       .pipelinesLogs(params)
      )
      .then((response) => {
        dispatch({
          type: Types.GET_PIPELINES_LOGS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_PIPELINES_LOGS,
          payload: [],
        });
      });
  };
};

export const getUsePipelinesByCollection = (
 params
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(Pipelines
       .collectionsLogs(params)
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTIONS_LOGS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTIONS_LOGS,
          payload: [],
        });
      });
  };
};

export const getUsePipelinesByCollectionName = (nome_colecao,
 params
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(Pipelines
       .collectionLogs(`/${nome_colecao}`,params)
      )
      .then((response) => {
        dispatch({
          type: Types.GET_COLLECTION_LOGS,
          payload: response.data,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_COLLECTION_LOGS,
          payload: [],
        });
      });
  };
};

export const getLogsExecution = (filePath,
 params
) => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });
    axiosInstanceV2
      .get(Pipelines
       .logsExecution(`${filePath}`,params)
      )
      .then((response) => {
        dispatch({
          type: Types.GET_EXECUTION_LOGS,
          payload: response.data.logs,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_EXECUTION_LOGS,
          payload: [],
        });
      });
  };
};



